export const drawerWidth = 240
export const drawerWidthCollapsed = drawerWidth / 4

export enum ProductRequestStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export const Locales = {
  en: { value: 'en', display: 'English' },
  nb: { value: 'nb', display: 'Norwegian' },
} as const

export enum OrderSuggestionType {
  Info = 'Info',
  Warning = 'Warning',
  Critical = 'Critical',
}

export enum DialogContextTypes {
  workshop = 'workshopDialog',
  boat = 'boatDialog',
  workshopCalander = 'workshopCalander',
  intranet = 'intranet',
}

export enum ThemeModes {
  Dark = 'dark',
  Light = 'light',
}

export enum DropItemTypes {
  SectionItem = 'section_item',
  SectionVariable = 'section_variable',
  SectionTemplate = 'section_template',
}

export const ShareTokenTypes = {
  WorkOrder: 'WorkOrder',
  WorkOrderSection: 'WorkOrderSection',
}

export enum ChecklistType {
  Regular = 'Regular',
  Startup = 'Startup',
  Workshop = 'Workshop',
  AdditionalItems = 'AdditionalItems',
}

export enum RiskAnalysisRiskStatus {
  NotEvaluated = 0,
  Low = 3,
  Moderate = 5,
  High = 6,
}

export enum RiskAnalysisLevelType {
  Probability,
  Consequence,
}

export enum WorkshopUserRole {
  System = 'System',
  Admin = 'Admin',
  Regular = 'Regular',
}

export enum RoleType {
  System = 4,
  Client = 3,
  Crew = 1,
  Regular = 2,
  Workshop = 5,
  Stock = 6,
}

export enum StockUserRole {
  Administrator = 15,
  Regular = 16,
}

export enum WorkshopBoatStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  InProgress = 'InProgress',
  ForApproval = 'ForApproval',
  Completed = 'Completed',
}

export enum WorkshopCaseLogType {
  StatusChange = 'StatusChange',
  ResourceChange = 'ResourceChange',
  StartDateChange = 'StartDateChange',
  EndDateChange = 'EndDateChange',
}

export enum StockProductStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
}
export enum NotificationStatus {
  Unread = 'Unread',
  Read = 'Read',
}

export enum MainVesselType {
  Boat = 'Boat',
  Barge = 'Barge',
}

export enum BuildMaterial {
  Unset = 'Unset',
  Steel = 'Steel',
  Concrete = 'Concrete',
  Aluminium = 'Aluminium',
}

export enum KeyEventType {
  UP,
  DOWN,
}

export enum CalendarEventType {
  Document = 'Document',
  Equipment = 'Equipment',
  Deviation = 'Deviation',
  WorkOrder = 'WorkOrder',
  Service = 'Service',
  Event = 'Event',
  ExerciseOccurence = 'ExerciseOccurence',
}

export enum ServiceRepeatType {
  Unset = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
}

export enum BoatHullType {
  Catamaran = 1,
  SingleHull = 2,
}

export enum VesselType {
  Boat = 'Boat',
  Barge = 'Barge',
}

export enum FileType {
  Image = 'image',
  File = 'file',
}

export enum BoatCounterType {
  Hour = 1,
  Calendar = 2,
  ManualConsumption = 3,
}

export enum ChecklistItemType {
  Title = 'Title',
  Description = 'Description',
  Text = 'Text',
  Number = 'Number',
  Checkbox = 'Checkbox',
  MultilineText = 'MultilineText',
  Media = 'Media',
  Slider = 'Slider',
  DateTime = 'DateTime',
  Counter = 'Counter',
  Refuel = 'Refuel',
  Location = 'Location',
  BoatValues = 'BoatValues',
}

export enum DefaultRoles {
  ClientAdmin = 10,
}

export enum LocationType {
  WorkOrder = 1,
  WorkShop = 2,
  Stock = 3,
}

export enum StockProductTransactionType {
  Add = 1,
  Remove = 2,
}
export enum WorkOrderStatus {
  New = 0,
  InProgress = 1,
  Done = 2,
}

export enum RoleCategory {
  Admin = 1,
  Resource = 2,
  System = 3,
  Regular = 4,
}
